import { render, staticRenderFns } from "./releaseIncubator.vue?vue&type=template&id=4eed920b&scoped=true&"
import script from "./releaseIncubator.vue?vue&type=script&lang=js&"
export * from "./releaseIncubator.vue?vue&type=script&lang=js&"
import style0 from "./releaseIncubator.vue?vue&type=style&index=0&id=4eed920b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eed920b",
  null
  
)

export default component.exports